import envConfig from "./env_config";

// BASE_URLS
export const RESUME_PARSER_BASE_URL = envConfig.baseURLs.resumeParserBaseURL;
export const VYLABS_BASE_URL = envConfig.baseURLs.vyLabsBaseURL;
export const VYLABS_USER_DASHBOARD_URL = envConfig.baseURLs.userDashboardURL;
export const IRMT_CANDIDATE_SEARCH_BASE_URL =
  envConfig.baseURLs.irmtCandidateSearchBaseURL;
// Dice Search
export const DICE_SEARCH_BASE_URL = envConfig.baseURLs.diceSearchBaseURL;

// Monster Search
export const MONSTER_SEARCH_BASE_URL = envConfig.baseURLs.monsterSearchBaseURL;

// PORTALS API'S :-

export const DICE_SEARCH_LOGIN_URL = envConfig.diceSearchLoginURL;
export const DICE_CANDIDATE_PROFILE_VIEW =
  envConfig.dice_candidate_profile_view;
export const DICE_BASIC_SEARCH_URL = envConfig.dice_basic_search_url;

export const MONSTER_TOKEN_URL = envConfig.monster_token_url;
export const MONSTER_VIEW = envConfig.monster_view;
export const MONSTER_SEARCH = envConfig.monster_search;

export const IRMT_CANDIDATE_CALL_STAGE = envConfig.irmt_candidate_call_stage;
export const IRMT_CANDIDATE_VIEW = envConfig.irmt_candidate_view;
export const IRMT_CANDIDATE_SEARCH_COUNTRY =
  envConfig.irmt_candidate_search_country;
export const IRMT_CANDIDATE_RECRUITER = envConfig.irmt_candidate_recruiters;
export const IRMT_CANDIDATE_SEARCH = envConfig.irmt_candidate_search;

export const MONSTER_VIEW_USA = envConfig.monster_view_usa;
export const MONSTER_TOKEN_USA_URL = envConfig.monster_token_usa_url;
export const MONSTER_SEARCH_USA = envConfig.monster_search_usa;

// Admin METRICS API'S :-

export const GET_OVERALL_CANDIDATES_COUNT = envConfig.overall_Candidates_Count;
export const GET_OVERALL_CLIENTS_COUNT = envConfig.overall_Clients_Count;
export const GET_OVERALL_ACTIVE_JOBS_COUNT =
  envConfig.overall_Active_Jobs_Count;
export const GET_ADMIN_CANDIDATE_CREATE_TODAY_COUNT =
  envConfig.admin_Candidates_Created_Today;
export const GET_ADMIN_TOTAL_CLIENTS_COUNT = envConfig.get_Admin_Clients_Count;
export const ADMIN_RECENT_TRACK = envConfig.admin_recent_track_history;
export const ADMIN_RECRUITMENT_OVERVIEW = envConfig.admin_recruitment_overview;
export const ADMIN_JOB_PIPELINE = envConfig.admin_job_pipeline;
export const ADMIN_RECRUITMENT_PERFORMANCE =
  envConfig.admin_recruitment_performance;
export const ADMIN_TEAM_WORKLOAD = envConfig.admin_team_workload;
export const ADMIN_RECRUITMENT_FUNNEL = envConfig.admin_recruitment_funnel;
export const ADMIN_METRICS_JOB_APPLICATIONS =
  envConfig.admin_metrics_job_applications;
export const ADMIN_METRICS_RECRUITER_APPLICATIONS =
  envConfig.admin_metrics_recruiter_applications;

// Member METRICS API'S :-

export const GET_CANDIDATE_STAGE_COUNT_BY_USER =
  envConfig.get_candidates_stagecount_byuser;
export const GET_OVERALL_CANDIDATE_COUNT =
  envConfig.fetch_Total_Candidate_Count;
export const GET_JOB_COUNT_BY_MONTH = envConfig.get_Job_CountBy_Month;
export const GET_ACTIVE_JOBS = envConfig.fetch_Active_Jobs;
export const GET_CANDIDATE_BY_STAGE = envConfig.get_candidate_by_stage;
export const FETCH_TOTAL_CAN_COUNT_BY_USER =
  envConfig.fetch_Total_Candidate_Count_By_User;
export const RECENT_TRACKS = envConfig.recent_tracks;
export const GET_TODAY_TRACKS_BY_USER = envConfig.get_today_tracks_by_user;

// API_CALLS
export const SIGNUP_URL = envConfig.signUpUrl;
export const LOGIN_URL = envConfig.loginUrl;
export const SEND_OTP = envConfig.sendOtp;
export const VERIFY_OTP = envConfig.verifyOtp;
export const PARSED_RESUME_URL = envConfig.parseResumeUrl;
export const PROCESS_UPLOAD_FILE = envConfig.processUploadedFile;
export const GET_RESUME_PRESIGNED_URL = envConfig.get_resume_presigned_url;
export const WEB_SOCKET_URL = envConfig.WebSocketUrl;
export const CREATE_CHAT_CHANNEL_URL = envConfig.create_Chat_Channel_Url;
export const GET_CHAT_CHANNEL_LIST_URL = envConfig.get_Chat_Channels_Url;
export const GET_CHAT_MESSAGES_LIST_URL = envConfig.get_Chat_Messages_Url;
export const SEND_CHAT_MESSAGE_URL = envConfig.send_Chat_Message_Url;
export const PROCESS_MESSAGE_URL = envConfig.process_Message_Url;
export const DELETE_CHAT_CHANNEL_URL = envConfig.delete_Chat_Channel_Url;
export const GENERATE_JOB_DESCRIPTION = envConfig.generate_Job_Description;
export const RENEW_ACCESS_TOKEN = envConfig.renewAccessToken;
export const CAN_LIST = envConfig.candidate_list;
export const GET_CANDIDATE_BY_ID = envConfig.get_candidate_by_id;
export const CCREATE_CAN = envConfig.create_candidate;
export const SIMPLE_SEARCH_CANDIDATES = envConfig.simple_search_candidates;
export const SIMPLE_SEARCH_CANDIDATES_EXCEL_EXPORT =
  envConfig.simple_search_candidates_excel_export;
export const GET_CANDIDATES_EXPORT_FIELDS = envConfig.candidate_export_fields;
export const CREATE_CANDIDATE_DOCUMENTS = envConfig.candidate_documents_create;
export const GET_CANDIDATE_DOCUMENTS_URL = envConfig.candidate_documents_geturl;
export const GET_CANDIDATE_DOCUMENTS_LIST = envConfig.candidate_documents_list;
export const DELETE_CANDIDATE_DOCUMENTS = envConfig.delete_candidate_documents;
export const CANDIDATE_FILTER_EXPORT = envConfig.candidate_filter_export;

export const JOBS_LIST = envConfig.jobs_list;
export const GET_JOB_DETAILS_BY_ID = envConfig.get_job_details_by_id;
export const SEARC_JOBS = envConfig.search_jobs;
export const UPDATE_JOBS_STATUS = envConfig.update_jobs_status;
export const GET_JOBS_STATUS = envConfig.get_jobs_status;
export const JOBS_SIMPLE_SEARCH = envConfig.job_simple_search;
export const JOBS_BY_CANDIDATE = envConfig.jobs_by_candidate;
export const JOBS_DOCUMENTS_GET_UPLOAD_URL =
  envConfig.jobs_document_get_upload_url;
export const JOBS_DOCUMENTS_CREATE = envConfig.jobs_document_create;
export const JOBS_DOCUMENTS_DELETE = envConfig.jobs_document_delete;
export const JOBS_DOCUMENTS_LIST = envConfig.jobs_document_list;
export const JOBS_PROCESS_JD = envConfig.jobs_process_jd;
export const JOBS_PROCESS_EXCEL = envConfig.jobs_process_excel;

export const PROCESS_EXCEL_URL = envConfig.process_excel_url;
export const LINK_CANDIDATE_RESUME = envConfig.link_candidate_resume;
export const DOWNLOAD_CANDIDATE_RESUME = envConfig.download_resume;
export const EMAIL_HISTORY_CANDIDATE = envConfig.email_history_candidate;
export const CANDIDATE_REMARKS_TRACK_LIST =
  envConfig.candidate_remarks_track_list;
export const CANDIDATE_REMARKS_TRACK_UPDATE =
  envConfig.candidate_remarks_track_update;
export const CANDIDATE_REMARKS_TRACK_DELETE =
  envConfig.candidate_remarks_track_delete;

// Clients API's : -
export const CREATE_CLIENT = envConfig.create_Client;
export const UPDATE_CLIENT = envConfig.update_client;
export const GET_CLIENTS_LIST = envConfig.get_Clients_List;
export const SEARCH_CLIENTS = envConfig.search_clients;
export const CREATE_CLIENT_TRACKING = envConfig.create_client_tracking;
export const CLIENT_TRACKING = envConfig.client_tracking;
export const DELETE_CLIENT_DETAILS = envConfig.delete_client_details;
export const SEARCH_CLIENT_CONTACTS = envConfig.search_client_contacts;
export const GET_CLIENT_DETAILS = envConfig.get_Client_Details;
export const UPDATE_CLIENT_INFO = envConfig.update_client_info;
export const GET_JOB_LIST_BY_CLIENT = envConfig.get_Job_List_By_Client;
export const CREATE_CLIENT_CONTACT = envConfig.create_client_contact;
export const UPDATE_CLIENT_CONTACT = envConfig.update_client_contact;
export const DELETE_CLIENT_CONTACT = envConfig.delete_client_contact;
export const PROCESS_CLIENT_EXCEL_URL = envConfig.process_client_excel_url;
// Client Documents API :-
export const CREATE_CLIENT_DOCUMENTS = envConfig.clients_documents_create;
export const GET_CLIENT_DOCUMENTS_URL = envConfig.clients_documents_geturl;
export const GET_CLIENT_DOCUMENTS_LIST = envConfig.clients_documents_list;
export const DELETE_CLIENT_DOCUMENTS = envConfig.delete_clients_documents;
export const CREATE_JOB = envConfig.create_job;
export const CREATE_CANDIDATE_TRACKING_HISTORY =
  envConfig.create_Candidate_Tracking_History;
export const GET_TRACKING_HISTORY_BY_CANDIDATE =
  envConfig.get_Tracking_History_By_Candidate;
export const GET_APPLICATION_BY_JOB = envConfig.get_Applicationsy_By_Job;
export const FIND_SIMILAR_RESUMES = envConfig.find_similar_resumes;
export const SEARCH_JOB_DESC = envConfig.search_job_desc;
export const SEARCH_RESUMES = envConfig.search_resumes;

export const SCHEDULE_INTERVIEW = envConfig.scheduling_interview;
export const INTERVIEWS_LIST = envConfig.interview_display;
export const INTERVIEW_PANEL_SET=envConfig.interview_panel_set
export const INTERVIEW_PANEL_FEEDBACK=envConfig.interview_panel_feedback
export const GET_INTERVIEW_PANEL_DETAILS=envConfig.get_interview_panel_details
export const GET_RESUME_BY_ID = envConfig.get_resume_by_id;
export const DELETE_INTERVIEW = envConfig.delete_interview;
export const UPDATE_INTERVIEW = envConfig.update_interview;
export const GET_INTERVIEWS_BY_ID = envConfig.interview_by_id;
export const GET_INTERVIEWS_BY_APPLICATION_ID =
  envConfig.interview_by_application_id;
export const INTERVIEW_EMAIL_PREVIEW = envConfig.interview_email_preview;
export const INTERVIEW_BY_CANDIDATE = envConfig.interview_by_candidate;
export const APPLICATIONS_LIST = envConfig.apllications_list;
export const GET_RECRUITER_BY_ID = envConfig.get_recuirter_by_id;
export const UPDATE_RESSUME_BY_CANID = envConfig.update_resume_by_candidateid;

export const GET_INTERVIEW_BY_TIME_RANGE =
  envConfig.get_interview_by_time_range;
export const UPDATE_JOB = envConfig.update_job;
export const DELETE_CANDIDATE_RESUME_BY_FILEID =
  envConfig.delete_candidate_resume_by_fileid;
export const UPDATE_APPLICATION = envConfig.update_application;
export const APPLICATIONS_TRACKS_UPDATE = envConfig.applications_tracks_update;
export const APPLICATIONS_TRACKS_DELETE = envConfig.applications_tracks_delete;
export const TRACKING_APPLICATION = envConfig.tracking_application;
export const PROCESS_CANDIDATE_CONVERSATION = envConfig.candidate_conversation;
export const PROCESS_JOB_CONVERSATION = envConfig.job_conversation;
export const GET_CURRENT_CONVERSATION_TITLE =
  envConfig.get_current_conversation_title;
export const DELETE_JOB_DETAILS = envConfig.delete_job_details;
export const DELETE_CANDIDATE_DETAILS = envConfig.delete_candidate_details;
export const CHANGE_PASSWORD = envConfig.change_password;
export const USER_FORGOT_PASSWORD = envConfig.user_forgot_password;
export const USER_RESET_PASSWORD = envConfig.user_reset_password;

export const CANDIDATE_TRACK_BY_USER = envConfig.get_candidate_track_by_id;
export const JOBS_PUBLIC_URL = envConfig.job_public_url;
export const CREATE_JOB_URL = envConfig.create_job_url;
export const SHOW_URL_JOB_DETAILS = envConfig.show_url_job_details;
export const PARSE_URL_RESUME = envConfig.parse_url_resume;
export const UPLOAD_CANDIDATE_IMAGE = envConfig.upload_candidate_image;
export const UPLOAD_USER_IMAGE = envConfig.upload_user_image;
export const USERS_REMOVE_IMAGE = envConfig.users_remove_image;
export const CANDIDATES_REMOVE_IMAGE = envConfig.candidates_remove_image;
export const CANDIDATE_TRACKED_BY_ME = envConfig.candidate_tracked_by_me;
export const RECOMMEND_JOBS = envConfig.recommend_jobs;
export const UPDATE_CANDIDATE_DETAILS = envConfig.update_candidate_details;
export const CREATE_RUN_SET_ID = envConfig.create_run_set_id;
export const GET_UNPARSED_RESUMES_COUNT = envConfig.get_unparsed_resumes_count;
export const CHATBOT_EXECUTE_SCHEDULE_INTERVIEW =
  envConfig.chatbot_execute_schedule_interview;

// Vendors
export const GET_VENDOR_DETAILS_BY_ID = envConfig.get_vendor_details_by_id;
export const GET_VENDORS_LIST = envConfig.get_Vendors_List;
export const CREATE_VENDORS = envConfig.create_vendors;
export const UPDATE_VENDORS_INFO_FIELDS = envConfig.update_vendors_info_fields;
export const UPDATES_VENDORS_TRACK_FIELDS =
  envConfig.update_vendors_track_fields;
export const VENDORS_TRACKING_LIST = envConfig.vendors_tracking_list;
export const VENDORS_SEARCH = envConfig.vendors_search;
export const CANDIDATES_BY_VENDOR = envConfig.candidates_by_vendor;
export const GET_VENDOR_FILE_UPLOAD_URL = envConfig.get_vendor_file_upload_url;
export const VIEW_VENDOR_FILE_URL = envConfig.view_vendor_file_url;
export const CREATE_VENDORS_CONTACT = envConfig.create_vendor_contacts;
export const UPDATE_VENDOR_CONTACT = envConfig.edit_vendor_contact;
export const DELETE_VENDOR_CONTACT = envConfig.delete_vendor_contact;
export const EMAIL_HISTORY_CLIENT = envConfig.email_history_client;

// Tenants_API
export const CREATE_TENANT = envConfig.create_tenant_url;
export const ADD_USER_TO_TENANT = envConfig.add_user_to_tenant;
export const LIST_MEMEBERS_OF_TENANT = envConfig.list_members_of_tenant;
export const UPDATE_MEMBER_ROLE = envConfig.update_member_role;
export const REMOVE_MEMBER = envConfig.remove_member;
export const CREATE_INVITE_LINK = envConfig.create_invite_link;
export const JOIN_FROM_INVITE_LINK = envConfig.join_from_invite_link;
export const GET_TENANT_DETAILS = envConfig.get_tenant_details;
export const GET_CANDIDATES_BY_NOTES = envConfig.get_candidates_by_notes;

// Subscription_API
export const GET_SUBSCRIPTION_DETAILS = envConfig.get_subscription_details;

//User Dashboard_API
export const DASHBOARD_METRICS_LOGIN_URL = envConfig.dashboard_metrics_login;
export const USERS_UPDATE = envConfig.users_update;

// Subscription_Releted_Apis
export const SELECT_FREE_TRIAL_PLAN = envConfig.select_free_trial_plan;
export const UPDATE_SUBSCRIPTION_PLAN = envConfig.update_subscription_plan;
export const FETCH_BY_CALL_STAGE = envConfig.fetch_by_call_stage;

// Super Admin Related API:-
export const GET_ONE_TENANT_RESUMES_STATISTICS =
  envConfig.get_one_tenant_resumes_statistics;
export const GET_ALL_TENANT_RESUMES_STATISTICS =
  envConfig.get_all_tenant_resumes_statistics;

//Email Related API :-
export const REACH_OUT_CANDIDATE_EMAIL = envConfig.reach_out_candidate_email;
export const JOB_BLAST_FOR_CANDIDATES = envConfig.job_blast_for_candidates;
export const EMAIL_CLIENT = envConfig.email_client;
export const EMAIL_VENDOR = envConfig.email_vendor;
export const VENDOR_EMAIL_HISTORY = envConfig.email_history_vendor;

// Employee Related API :-
export const EMPLOYEE_CREATE = envConfig.employee_create;
export const EMPLOYEE_UPDATE = envConfig.employee_update;
export const EMPLOYEE_DELETE = envConfig.employee_delete;
export const GET_EMPLOYEE_DETAIL = envConfig.get_employee_detail;

// Employee Bank Details API :-
export const CREATE_EMPLOYEE_BANK_DETAILS =
  envConfig.create_employee_bank_details;
export const UPDATE_EMPLOYEE_BANK_DETAILS =
  envConfig.update_employee_bank_details;
export const DELETE_EMPLOYEE_BANK_DETAILS =
  envConfig.delete_employee_bank_details;
export const GET_EMPLOYEE_BANK_DETAILS_LIST =
  envConfig.get_employee_bank_details_list;
export const GET_EMPLOYEE_BANK_DETAIL = envConfig.get_employee_bank_detail;

// Employee Contact Details API :-
export const CREATE_EMPLOYEE_CONTACT_DETAILS =
  envConfig.create_employee_contact_details;
export const UPDATE_EMPLOYEE_CONTACT_DETAILS =
  envConfig.update_employee_contact_details;
export const DELETE_EMPLOYEE_CONTACT_DETAILS =
  envConfig.delete_employee_contact_details;
export const GET_EMPLOYEE_CONTACT_DETAILS_LIST =
  envConfig.get_employee_contact_details_list;
export const GET_EMPLOYEE_CONTACT_DETAIL =
  envConfig.get_employee_contact_detail;

// Employee BGV Records API :-
export const CREATE_EMPLOYEE_BGV_RECORDS =
  envConfig.create_employee_bgv_records_details;
export const UPDATE_EMPLOYEE_BGV_RECORDS =
  envConfig.update_employee_bgv_records_details;
export const DELETE_EMPLOYEE_BGV_RECORDS =
  envConfig.delete_employee_bgv_records_details;
export const GET_EMPLOYEE_BGV_RECORDS_LIST =
  envConfig.get_employee_bgv_records_details_list;
export const GET_EMPLOYEE_BGV_RECORD =
  envConfig.get_employee_bgv_records_detail;

// Preview Related API :-
export const REACH_OUT_CANDIDATE_EMAIL_PREVIEW =
  envConfig.reach_out_candidate_email_preview;
export const JOB_BLAST_FOR_CANDIDATES_PREVIEW =
  envConfig.job_blast_for_candidates_preview;
export const EMAIL_CLIENT_PREVIEW = envConfig.email_client_preview;
export const EMAIL_VENDOR_PREVIEW = envConfig.email_vendor_preview;

// Get All Plan Details :-
export const GET_ALL_PLANS_DETAILS = envConfig.get_all_plan_details;

// Irmt Candidate Search :-
export const IRMT_CANDIDATE_TOKEN_ID = envConfig.irmt_candidate_token_id;

// Feedback Related API:-
export const SEND_FEEDBACK = envConfig.send_feedback;
export const LIST_FEEDBACK = envConfig.list_feedback;

//  Tenant Logo Related API :-
export const UPLOAD_TENANT_LOGO = envConfig.upload_tenant_logo;
export const REMOVE_TENANT_LOGO = envConfig.remove_tenant_logo;

// Notification Related APIs :-
export const NOTIFICATIONS_GET = envConfig.notifications;
export const NOTIFICATIONS_READ_ALL = envConfig.notifications_read_all;
export const NOTIFICATIONS_READ_BY_ID = envConfig.notifications_read_by_id;

// online/offline tracking Related APIs :-
export const SEND_USER_ACTIVE_TRACK = envConfig.send_user_active_track;
export const GET_ALL_ONLINE_USERS_FROM_TENANT =
  envConfig.get_all_online_users_from_tenant;

// Tenants field-definitions API :-
export const TENANT_FIELD_DEFINITIONS_LIST =
  envConfig.tenant_field_definitions_list;
export const TENANT_FIELD_DEFINITIONS_CREATE =
  envConfig.tenant_field_definitions_create;
export const TENANT_FIELD_DEFINITIONS_UPDATE =
  envConfig.tenant_field_definitions_update;
export const TENANT_FIELD_DEFINITIONS_DELETE =
  envConfig.tenant_field_definitions_delete;
export const TENANT_FIELD_DEFINITIONS_REORDER =
  envConfig.tenants_field_definitions_reorder;

// Callback Reminders APIs :-
export const CALLBACK_REMAINDERS = envConfig.callback_reminders;
export const CALLBACK_REMAINDERS_CREATE = envConfig.callback_reminders_create;
export const CALLBACK_REMAINDERS_DELETE = envConfig.callback_reminders_delete;
export const CALLBACK_REMAINDERS_UPDATE = envConfig.callback_reminders_update;

// Custom Portals Credentials APIs :-
export const CREATE_CUSTOM_PORTALS = envConfig.create_custom_portal_credentials;
export const UPDATE_CUSTOM_PORTALS = envConfig.update_custom_portal_credentials;
export const DELETE__CUSTOM_PORTALS =
  envConfig.delete_custom_portal_credentials;
export const GET_CUSTOM_PORTALS = envConfig.get_custom_portal_credentials;

// Member Dashboard APIs :-
export const METRICS_RECRUITER_DASHBOARD_SUMMARY =
  envConfig.metrics_recruiter_dashboard_summary;
export const METRICS_RECENT_ACTIVITY = envConfig.metrics_recent_activity;
export const METRICS_CANDIDATE_WORKSPACE =
  envConfig.metrics_candidate_workspace;
export const METRICS_RECRUITER_DASHBOARD_FOLLOWUPS =
  envConfig.metrics_recruiter_dashboard_followups;
export const METRICS_JOB_WORKSPACE = envConfig.metrics_job_workspace;

//Daily-Reports API's : -
export const GET_ALL_REPORTS = envConfig.get_all_reports;
export const SUBMIT_DAILY_REPORT = envConfig.submit_daily_report;
export const UPDATE_DAILY_REPORT = envConfig.update_report;
export const DELETE_DAILY_REPORT = envConfig.delete_report;
export const GET_DAILY_REPORT = envConfig.get_report_details;

//Invoices-Page API's :-
export const GET_INVOICE_CANDIDATES = envConfig.get_invoice_candidates;
export const INVOICE_CREATE = envConfig.invoice_create;
export const INVOICE_PREVIEW = envConfig.invoice_preview;
export const INVOICE_CALCULATE_BILLING = envConfig.invoice_calculate_billing;
export const INVOICE_CALCULATE_MARGIN = envConfig.invoice_calculate_margin;
export const INVOICE_DOWNLOAD = envConfig.invoice_download;
export const INVOICE_UPDATE = envConfig.invoice_update;
export const INVOICE_GET_BY_ID = envConfig.invoice_get;
export const CHANGE_INVOICE_STATUS = envConfig.change_invoice_status;

// Super Admin Dashboard APIs :-
export const SUPERADMIN_METRICS_ACTIVITY_BY_TENANT =
  envConfig.superadmin_metrics_activity_by_tenant;
export const EXPORT_SUPERADMIN_METRICS_ACTIVITY_BY_TENANT =
  envConfig.export_superadmin_metrics_activity_by_tenant;
export const SUPERADMIN_METRICS_ACTIVITY_BY_USER =
  envConfig.superadmin_metrics_activity_by_user;
export const EXPORT_SUPERADMIN_METRICS_ACTIVITY_BY_USER =
  envConfig.export_superadmin_metrics_activity_by_user;
export const SUPERADMIN_TENANT_SUBSCRIPTION =
  envConfig.superadmin_tenant_subscription;

//Invoice-Configuration-Page API's :-
export const SUBMIT_FINANCIAL_CREATE = envConfig.submit_financial_profile;
export const UPDATE_FINANCIAL_PROFILE = envConfig.update_financial_profile;
export const GET_FINANCIAL_LIST = envConfig.get_financial_profile_list;
export const DELETE_FINANCIAL_PROFILE = envConfig.delete_financial_profile;

export const TAX_CONFIG_LIST = envConfig.get_config_list;
export const TAX_CONFIG_CREATE = envConfig.submit_tax_create;
export const TAX_CONFIG_UPDATE = envConfig.update_tax_config;
export const TAX_CONFIG_DELETE = envConfig.delete_tax_config;

// call stages and custom fields APIs :-
export const TENANTS_APPLICATION_STAGES_LIST =
  envConfig.tenants_application_stages_list;
export const TENANTS_CREATE_APPLICATION_STAGE =
  envConfig.tenants_create_application_stage;
export const TENANTS_UPDATE_APPLICATION_STAGE =
  envConfig.tenants_update_application_stage;
export const TENANTS_REORDER_APPLICATION_STAGES =
  envConfig.tenants_reorder_application_stages;
export const TENANTS_DELETE_APPLICATION_STAGE =
  envConfig.tenants_delete_application_stage;

// Vendor pipeline related APIs:-
export const VENDOR_PIPELINE_METRICS = envConfig.vendor_pipeline_metrics;
export const VENDOR_PIPELINES_ACTIONS = envConfig.vendor_pipeline_actions;

// Saved filter views (user-specific)
export const CREATE_SAVED_VIEWS = envConfig.create_saved_views;
export const UPDATE_SAVED_VIEWS = envConfig.update_saved_views;
export const DELETE_SAVED_VIEWS = envConfig.delete_saved_views;
export const GET_SAVED_VIEWS = envConfig.get_saved_views;

// Public job board APIs :-
export const GET_TENANTS_LOGO = envConfig.get_tenants_logo;
